import { Button } from '@material-ui/core';
import clsx from 'clsx';
import { FC } from 'react';
import { WizardLayout } from '../shared/components';
import StepEmail from './components/StepEmail';
import StepInfos from './components/StepInfos';
import { TOTAL_STEPS } from './constants';
import { useStyles } from './styles';
import { useCreateConsultantWizard } from './useCreateConsultantWizard';

const CreateConsultant: FC = () => {
  const classes = useStyles();
  const wizard = useCreateConsultantWizard();

  const nextDisabled =
    wizard.submitting ||
    wizard.checkingEmail ||
    !wizard.isEmailValid ||
    Boolean(wizard.existingUser);

  return (
    <WizardLayout
      classes={classes}
      backLabel="← Retour à la liste"
      onBack={wizard.goBack}
      title={wizard.pageTitle}
      step={wizard.step}
      totalSteps={TOTAL_STEPS}
      hideProgress={true}
      bodyClassName={classes.body}
      footerClassName={clsx(classes.footer, wizard.step === 1 && classes.footerEnd)}
      footer={
        <>
          {wizard.step > 1 && (
            <Button className={classes.secondaryBtn} onClick={wizard.goPrevious}>
              ← Précédent
            </Button>
          )}
          {wizard.step === 1 && (
            <Button className={classes.primaryBtn} disabled={nextDisabled} onClick={wizard.goNext}>
              Suivant →
            </Button>
          )}
          {wizard.step === 2 && (
            <Button
              className={classes.primaryBtn}
              disabled={wizard.submitting || !wizard.canSubmit}
              onClick={wizard.handleSubmit}>
              {wizard.submitting ? 'Enregistrement...' : 'Enregistrer'}
            </Button>
          )}
        </>
      }>
      {wizard.step === 1 && (
        <StepEmail
          email={wizard.email}
          existingUser={wizard.existingUser}
          checkingEmail={wizard.checkingEmail}
          roleLabel={wizard.existingRoleLabel}
          onEmailChange={wizard.handleEmailChange}
          onViewProfile={wizard.openExistingUserProfile}
        />
      )}
      {wizard.step === 2 && (
        <StepInfos
          infos={wizard.infos}
          roles={wizard.roles}
          managers={wizard.managers}
          services={wizard.services}
          categoryTests={wizard.categoryTests}
          showServices={wizard.isConsultantRole}
          onChange={wizard.updateInfos}
        />
      )}
    </WizardLayout>
  );
};

export default CreateConsultant;
